import styled from 'styled-components';


export const Wrapper = styled.div`
    background: white;
    padding: 50px;
    display: flex;
    flex-direction: row;
    gap: 10px;
`;
